// =============================================================================
// Services Swiper — inside the Services mega-dropdown. Lazy-init on first
// hover/click so the slider measures itself AFTER the panel becomes visible.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        if (typeof Swiper === 'undefined') { return; }

        const $container = $('[data-services-swiper]');
        if (!$container.length) { return; }

        let instance = null;

        function init() {
            if (instance) { return instance; }
            instance = new Swiper($container[0], {
                slidesPerView: 'auto',
                spaceBetween: 35,
                loop: false,
                watchOverflow: true,
                navigation: {
                    nextEl: '.services-swiper__nav--next',
                    prevEl: '.services-swiper__nav--prev',
                },
                breakpoints: {
                    0:    { slidesPerView: 'auto', spaceBetween: 16 },
                    768:  { slidesPerView: 'auto', spaceBetween: 24 },
                    1280: { slidesPerView: 'auto', spaceBetween: 35 },
                },
            });
            return instance;
        }

        const $servicesTrigger = $('[data-mega-trigger="services"]');
        const $servicesItem    = $('[data-mega="services"]');

        function lazyInit() {
            init();
            // Re-measure once visible — opacity transition delays layout.
            setTimeout(() => { if (instance) { instance.update(); } }, 250);
        }

        $servicesTrigger.on('click', lazyInit);
        $servicesItem.on('mouseenter', lazyInit);
    });
})(jQuery);
